export default "__VITE_ASSET__e48fd5e9__"